import { Edit, TabbedForm, useCanAccess } from 'react-admin';
import { MerchantResource } from '../../Entities/Merchant';
import SummaryTab from './Forms/SummaryTab';
import ContactInfoTab from './Forms/ContactInfoTab';
import AddressTab from './Forms/AddressTab';
import BillingInfoTab from './Forms/BillingInfoTab';
import MerchantConfigTab from './Forms/MerchantConfigTab';
import RemarksTab from './Forms/RemarksTab';
import ScannerTab from './Forms/ScannerTab';
import EditToolbar from '../../Components/EditToolbar';
import { ReactElement } from 'react';

export default function MerchantEdit(): ReactElement {
  const affiliateNetworkAccess = useCanAccess({ action: 'list', resource: 'affiliate_networks' });
  const countryAccess = useCanAccess({ action: 'list', resource: 'countries' });
  const feedAccess = useCanAccess({ action: 'list', resource: 'feeds' });
  const merchantStatusAccess = useCanAccess({ action: 'list', resource: 'merchant_statuses' });
  const payAccountAccess = useCanAccess({ action: 'list', resource: 'pay_accounts' });
  const registrationAccess = useCanAccess({ action: 'list', resource: 'registrations' });
  const regionAccess = useCanAccess({ action: 'list', resource: 'regions' });
  const scanAccess = useCanAccess({ action: 'list', resource: 'scans' });
  const shopScansAccess = useCanAccess({ action: 'list', resource: 'shop_scans' });
  const stateAccess = useCanAccess({ action: 'list', resource: 'states' });

  const prefetch: string[] = [];
  if (affiliateNetworkAccess.canAccess) prefetch.push('affiliate_network');
  if (countryAccess.canAccess) prefetch.push('country');
  if (feedAccess.canAccess) prefetch.push('feeds');
  if (merchantStatusAccess.canAccess) prefetch.push('merchant_status');
  if (payAccountAccess.canAccess) prefetch.push('pay_account');
  if (registrationAccess.canAccess) prefetch.push('registration');
  if (regionAccess.canAccess) prefetch.push('region');
  if (scanAccess.canAccess) prefetch.push('shop_scans.scan');
  if (shopScansAccess.canAccess) prefetch.push('shop_scans');
  if (stateAccess.canAccess) prefetch.push('state');

  return (
    <Edit<MerchantResource> mutationMode="pessimistic" queryOptions={{ meta: { prefetch } }}>
      <TabbedForm toolbar={<EditToolbar />}>
        <SummaryTab />
        <MerchantConfigTab />
        <AddressTab />
        <ContactInfoTab />
        <BillingInfoTab />
        <ScannerTab />
        <RemarksTab />
      </TabbedForm>
    </Edit>
  );
}
